import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "menu-admin-component",
  class: "text-white fs-6"
}
const _hoisted_2 = { class: "row ms-0" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row red-color text-center" }
const _hoisted_5 = { class: "col fs-5" }
const _hoisted_6 = { class: "row ms-0 fs-4" }
const _hoisted_7 = {
  class: "col-11 offset-1 border pt-2",
  id: "categories-container"
}
const _hoisted_8 = { class: "ps-0 text-18px" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": '#menu-history',
  "aria-controls": 'menu-history'
}
const _hoisted_11 = {
  id: 'menu-history',
  class: "accordion-collapse collapse"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_ctx.userStore.checkFeatureAccess('cart_history'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.labelMenuHistory), 1),
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", {
                    key: "carts",
                    class: "fs-5 list-style-none text-underline",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/history/carts')))
                  }, _toDisplayString(_ctx.labelMenuHistoryCarts), 1),
                  _createElementVNode("li", {
                    key: "ftpReceived",
                    class: "fs-5 list-style-none text-underline",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/history/photos-ftp-received')))
                  }, _toDisplayString(_ctx.labelMenuHistoryFtpReceived), 1),
                  _createElementVNode("li", {
                    key: "logins",
                    class: "fs-5 list-style-none text-underline",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/history/logins')))
                  }, _toDisplayString(_ctx.labelMenuHistoryLogins), 1),
                  _createElementVNode("li", {
                    key: "logins",
                    class: "fs-5 list-style-none text-underline",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/history/photo-searchs')))
                  }, _toDisplayString(_ctx.labelMenuHistoryPhotoSearchs), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.userStore.checkFeatureAccess('users'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createElementVNode("button", {
                  class: "border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/users')))
                }, _toDisplayString(_ctx.menuUsers), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.userStore.checkFeatureAccess('validation'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("button", {
                  class: "border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/photoValidation')))
                }, _toDisplayString(_ctx.menuPhotoValidation), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}